import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Table, Tag } from "antd";
import { del, get } from "../../api/axios";
import { Pagination, message } from "antd";
import { checkPermission } from "../auth/ProtectedRoutes";
import SearchBar from "../../utils/SearchBar";

const OwnersRates = () => {
  // ant-table-content
  const columns = [
    //1
    {
      title: " الرقم   ",
      dataIndex: "id",
    },

    //2
    {
      title: (
        <>
          رقم الحجز
          <br />
          كود الوحدة
          <br />
          تاريخ الانشاء
        </>
      ),

      render: ({ reservation_number, date, property_code }) => (
        <>
          {reservation_number || "-"}
          <br />
          {property_code || "-"}
          <br />
          {date || "-"}
        </>
      ),
    },

    //3
    {
      title: (
        <>
          تاريخ التقييم
          <br />
          رقم المضيف
          <br />
          عرض التعليق
        </>
      ),

      render: ({ owner_phone_number, reservation_date, owner_comment }) => (
        <>
          {reservation_date || "-"}
          <br />
          <>-</>
          <br />
          {owner_comment || "-"}
        </>
      ),
    },

    //4
    {
      title: (
        <>
          اللباقة
          <br />
          النظافة
          <br />
          الحرص
        </>
      ),

      render: ({
        tact_number,
        tact_text,
        clean_number,
        clean_text,
        care_number,
        care_text,
      }) => (
        <>
          <span>
            {tact_number} ({tact_text})
          </span>
          <br />
          <span>
            {clean_number} ({clean_text})
          </span>
          <br />
          <span>
            {care_number} ({care_text})
          </span>
        </>
      ),
    },

    //5
    {
      title: (
        <>
          التعليمات
          <br />
          مستوى الرضا
        </>
      ),

      render: ({
        instructions_number,
        instructions_text,
        satisfaction_number,
        satisfaction_text,
      }) => (
        <>
          <span>
            {instructions_number} ({instructions_text})
          </span>
          <br />
          <span>
            {satisfaction_number} ({satisfaction_text})
          </span>
          <br />
        </>
      ),
    },

    {
      title: " التقييم العام  ",
      render: ({ total_rate_number, total_rate_text }) => (
        <span>
          {total_rate_number} <br /> ({total_rate_text})
        </span>
      ),
    },

    {
      title: "  حالة الرد ",
      render: ({ status }) => (
        <>
          <Tag color={`${status == "محذوف" ? "error" : "success"}`}>
            {status}
          </Tag>
        </>
      ),
    },
  ];
  //
  if (checkPermission("delete-owner-rate")) {
    columns.push({
      title: "ادارة الرد",
      render: ({ id, status }) => (
        <Popconfirm
          disabled={status == "محذوف" ? true : false}
          title="حذف العنصر"
          description="هل أنت متأكد من حذف هذه العنصر؟"
          onConfirm={() => confirm(id)}
          onCancel={cancel}
          okText="نعم"
          cancelText="لا"
        >
          <Button danger disabled={status == "محذوف" ? true : false}>
            حذف
          </Button>
        </Popconfirm>
      ),
    });
  }
  const handleDelet = (id) => {
    del(`delete-owner-rate/${id}`);

    const newData = [];
    data.map((item) => {
      if (item.id == id) {
        newData.push({ ...item, status: "محذوف" });
      } else {
        newData.push(item);
      }
    });
    setdata(newData);
  };

  const confirm = (id) => {
    handleDelet(id);
    message.success("تم الامر بنجاح");
  };
  const cancel = (e) => {
    //console.log(e);
    message.error("تم الغاء الامر");
  };
  const [dataFirst, setdataFirst] = useState([]);
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get(`get-owners-rates?search=${searchQuery}`).then((res) => {
      setdataFirst(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);

  useEffect(() => {
    //console.log("dataFirst", dataFirst);
    const newarr = [];
    dataFirst?.map((item) => {
      const newObj = {};

      // item
      newObj.id = item.id;
      newObj.property_code = item.property_code;
      newObj.owner_comment = item.owner_comment;
      newObj.rate_date = item.rate_date;
      newObj.reservation_number = item.reservation_number;

      newObj.date = item.reservation_date;

      newObj.reservation_date = item.date;
      newObj.owner_id = item.owner_id;
      newObj.owner_phone_number = item.owner_phone_number;
      newObj.user_phone_number = item.user_phone_number;
      newObj.user_id = item.user_id;

      // item
      newObj.tact_number = item.tact.number;
      newObj.tact_text = item.tact.text;
      // item
      newObj.clean_number = item.clean.number;
      newObj.clean_text = item.clean.text;
      // item
      newObj.care_number = item.care.number;
      newObj.care_text = item.care.text;
      // item
      newObj.instructions_number = item.instructions.number;
      newObj.instructions_text = item.instructions.text;
      // item
      newObj.satisfaction_number = item.satisfaction.number;
      newObj.satisfaction_text = item.satisfaction.text;
      // item
      newObj.total_rate_number = item.total_rate.number;
      newObj.total_rate_text = item.total_rate.text;

      newObj.status = item.status;

      newarr.push(newObj);
    });
    setdata(newarr);
  }, [dataFirst]);

  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`get-owners-rates?page=${pageNumber}`).then((res) => {
      setdataFirst(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                y: "65vh",
                x: 1750,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnersRates;
